import fr from "./fr";

// Add "en" here later for a full English interface
const dictionaries = { fr };
const current = "fr";

export const t = (key, vars = {}) => {
  const value = key.split(".").reduce((o, k) => (o ? o[k] : undefined), dictionaries[current]) ?? key;
  return typeof value === "string" ? value.replace(/\{(\w+)\}/g, (_, v) => vars[v] ?? "") : value;
};
